import { render, staticRenderFns } from "./DocumentSelect.vue?vue&type=template&id=d70774a2&scoped=true"
import script from "./DocumentSelect.vue?vue&type=script&lang=js"
export * from "./DocumentSelect.vue?vue&type=script&lang=js"
import style0 from "./DocumentSelect.vue?vue&type=style&index=0&id=d70774a2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70774a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/apps/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d70774a2')) {
      api.createRecord('d70774a2', component.options)
    } else {
      api.reload('d70774a2', component.options)
    }
    module.hot.accept("./DocumentSelect.vue?vue&type=template&id=d70774a2&scoped=true", function () {
      api.rerender('d70774a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DocumentSelect/DocumentSelect.vue"
export default component.exports